// extracted by mini-css-extract-plugin
export default {"root":"GlobalNotificationBanner_root__V6Szp","appearAnimation":"GlobalNotificationBanner_appearAnimation__YsomG","banner":"GlobalNotificationBanner_banner__DWKN5"};